export default __webpack_public_path__ + "static/media/include_8@3x.c9e60c6b.jpg";